import React from 'react';
import { useIntl } from 'react-intl';
import { DefaultSearch } from '@americanexpress/dls-react';

const SearchBox = (props) => {
  const intl = useIntl();

  const placeholder = intl.formatMessage({
    id: 'view-all.search.search',
    defaultMessage: 'Search...',
  });
  const clearBtnLabel = intl.formatMessage({
    id: 'view-all.search.clear-btn',
    defaultMessage: 'Clear text',
  });
  const labelText = intl.formatMessage({
    id: 'view-all.search.label-text',
    defaultMessage: 'Questions and answers',
  });
  const searchBtnLabel = intl.formatMessage({
    id: 'view-all.search.title',
    defaultMessage: 'Search',
  });

  if (props.type === 'filter') {
    return (
      <DefaultSearch
        id={props.id}
        className='pad-2-r pad-3-r-lg-up'
        searchExperience={props.searchExperience}
        data-testid={props.dataTestid}
        aria-disabled={props.disabled}
        value={props.value}
        onClick={props.onClick}
        onChange={props.onChange}
        onClearSearch={props.onClearSearch}
        isLoading={props.loading}
        placeholder={placeholder}
        aria-label={labelText}
        autoFocus={props.autoFocus}
        clearButtonProps={props.clearButtonProps}
        reactlytics={props.reactlytics}
      />
    );
  }
  return (
    <DefaultSearch
      autoFocus={props.autoFocus}
      className='pad-2-r pad-3-r-lg-up'
      showSearchButton={props.buttonSearch}
      id={props.id}
      hint={labelText}
      isHintVisuallyHidden={true}
      onChange={props.onChange}
      onSearch={props.onSearch}
      aria-label={labelText}
      onClearSearch={props.onClearSearch}
      placeholder={placeholder}
      searchButtonProps={props.searchButtonProps}
      value={props.value}
      clearButtonProps={props.clearButtonProps}
      reactlytics={props.reactlytics}
      labelOverrides={{
        searchButtonScreenReaderLabel: searchBtnLabel,
        clearButtonScreenReaderLabel: clearBtnLabel,
      }}
    />
  );
};

export default SearchBox;
